export const getColorByScore = (score: number): string => {
  if (score <= 0) return "rgba(255, 255, 255, 1)";
  if (score <= 10) return "#FF0000";
  if (score <= 20) return "#FF6522";
  if (score <= 30) return "#FFAC63";
  if (score <= 40) return "#FFCE63";
  if (score <= 50) return "#FFDB63";
  if (score <= 60) return "#FFED63";
  if (score <= 70) return "#F3CE00";
  if (score <= 80) return "#C9D705";
  if (score <= 90) return "#98E706";
  return "#00C195";
};
